export const IMAGES = {
  workspace: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1200&q=80",
  server: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=1000&q=80",
  cityscape: "https://images.unsplash.com/photo-1595599014147-a419c147bdc0?auto=format&fit=crop&w=1200&q=80",
};

export const CONTACT = {
  phone: "07369 280596",
  email: "enquiries@groundbreakingit.co.uk",
  supportEmail: "support@groundbreakingit.co.uk",
  whatsapp: "https://wa.me/447369280596?text=Hi%20Groundbreaking%20IT%2C%20I%27d%20like%20a%20chat%20about%20our%20IT",
  area: "Glasgow, Edinburgh, Stirling, Falkirk, Livingston & the wider Central Belt",
  hours: "Monday to Friday, 8:30am–6:00pm",
};

export const TRUST_PILLS = [
  "15-Minute Avg Response",
  "100% Local Scottish Support",
  "Clear Monthly Agreements",
  "Microsoft 365 Expertise",
];

export const MARQUEE_ITEMS = [
  "Serving Glasgow",
  "Edinburgh",
  "Stirling",
  "Falkirk & the Forth Valley",
  "Livingston & West Lothian",
  "Straight Answers, No Nonsense",
  "Fixed Monthly Rates",
  "Direct Line to Senior Engineers",
];

export const SERVICES = [
  {
    id: "managed-it",
    icon: "Headset",
    title: "Managed IT Support",
    span: "md:col-span-6 lg:col-span-8",
    plain: "Your complete IT department for a predictable monthly fee. We monitor, maintain and support your team day to day.",
    outcome: "Fewer interruptions, and a 15-minute response when something breaks.",
    bullets: [
      "Unlimited helpdesk for your whole team",
      "Proactive monitoring, patching and maintenance",
      "New starter and leaver setups handled for you",
      "One simple monthly invoice, nothing hidden",
    ],
  },
  {
    id: "cyber-security",
    icon: "ShieldCheck",
    title: "Cyber Security",
    span: "md:col-span-6 lg:col-span-4",
    plain: "Ransomware protection, phishing defence, staff awareness training and compliance checks.",
    outcome: "Confidence that your customer and financial data is protected against attack.",
    bullets: [
      "Endpoint protection on every device",
      "Phishing simulations and staff training",
      "Cyber Essentials preparation, when you're ready for it",
      "Multi-factor authentication rolled out properly",
    ],
  },
  {
    id: "cloud-m365",
    icon: "CloudCog",
    title: "Microsoft 365 & Cloud",
    span: "md:col-span-4",
    plain: "Seamless migration of email, files and teamwork to Microsoft 365, without business interruption.",
    outcome: "Work securely from anywhere, with zero wasted licence costs.",
    bullets: [
      "Email and file migration with zero downtime",
      "SharePoint and Teams set up the way you work",
      "Licence reviews so you only pay for what you use",
      "Conditional access and security defaults applied",
    ],
  },
  {
    id: "network-infrastructure",
    icon: "Network",
    title: "Network & Infrastructure",
    span: "md:col-span-4",
    plain: "Fast, reliable office networking: firewalls, Wi-Fi, structured cabling and secure remote access.",
    outcome: "Reliable connectivity across the whole office, with no dead zones.",
    bullets: [
      "Business-grade firewalls and switching",
      "Full-coverage office Wi-Fi surveys and installs",
      "Secure remote access for hybrid teams",
      "Cabling and office moves planned end to end",
    ],
  },
  {
    id: "backup-recovery",
    icon: "DatabaseBackup",
    title: "Backup & Recovery",
    span: "md:col-span-4",
    plain: "Automated daily off-site backups, tested with real restoration drills.",
    outcome: "Recovery in under 2 hours, even if disaster or ransomware strikes.",
    bullets: [
      "Automated daily cloud and Microsoft 365 backups",
      "Quarterly restore tests, not just hope",
      "Ransomware-resilient, immutable copies",
      "A recovery plan you'll actually understand",
    ],
  },
  {
    id: "it-consultancy",
    icon: "Compass",
    title: "IT Consultancy & Projects",
    span: "md:col-span-6 lg:col-span-12",
    plain: "Strategic technology roadmaps, office relocations, hardware refresh planning and supplier management.",
    outcome: "Sensible technology investments aligned with your three-year growth plans.",
    bullets: [
      "Honest technology roadmaps tied to your budget",
      "Office moves and fit-outs managed for you",
      "Hardware lifecycle planning, no surprise failures",
      "We deal with technology suppliers so you don't have to",
    ],
  },
];

export const WHY_US = {
  legacy: [
    "Confusing 40-page contracts with hidden chargeables",
    "Outsourced call centres where you explain your issue three times",
    "Over-selling enterprise software you never use",
    "Slow reactions with vague SLA excuses",
  ],
  ours: [
    "One clear monthly contract that covers everything, written in plain language",
    "A direct line to engineers who know your name and setup",
    "Honest advice sized to your real business and budget",
    "A 15-minute average incident triage with clear updates",
  ],
};

export const STEPS = [
  { step: "01", name: "Discover", desc: "A free, comprehensive audit of your hardware, security and cloud setup." },
  { step: "02", name: "Stabilise", desc: "We fix the immediate pain points, clean up legacy lag and remove active risks." },
  { step: "03", name: "Secure", desc: "Multi-factor authentication, endpoint defence and daily backups, deployed properly." },
  { step: "04", name: "Support", desc: "Your team gets a direct line to friendly local engineers by phone, email or portal." },
  { step: "05", name: "Improve", desc: "Quarterly proactive reviews keep your technology lean, fast and modern." },
];

export const FAQS = [
  {
    q: "What is included in a Free IT Review?",
    a: "An independent assessment of your network security, backup status, Microsoft 365 licence efficiency and machine performance. You receive a clear, honest summary with actionable findings, yours to keep either way.",
  },
  {
    q: "Do you work on contracts or per hour?",
    a: "We work on a simple monthly agreement that covers your whole team, so you know exactly what IT costs each month. Everything is written in plain language, and we will talk you through the terms before you sign anything.",
  },
  {
    q: "How fast do you respond to urgent issues?",
    a: "Our average critical-incident response across the Central Belt is under 15 minutes, and you speak directly to a qualified technician.",
  },
  {
    q: "Can you take over from our current IT provider?",
    a: "Yes. We manage the whole handover, including the awkward conversations, and we never ask you to replace hardware that still works.",
  },
  {
    q: "Where is your team based?",
    a: "Proudly based in Scotland's Central Belt, supporting businesses across Glasgow, Edinburgh, Stirling, Falkirk and Livingston.",
  },
];

export const INDUSTRIES = [
  {
    id: "professional-services",
    icon: "Scale",
    title: "Professional Services",
    tagline: "Accountants, solicitors, consultants and agencies",
    pain: "Client confidentiality is everything, and billable hours stop the moment email or case software goes down.",
    help: [
      "Locked-down Microsoft 365 with proper access controls",
      "Reliable document management and rapid recovery",
      "Support that understands compliance deadlines",
    ],
  },
  {
    id: "healthcare-practices",
    icon: "Stethoscope",
    title: "Healthcare & Dental Practices",
    tagline: "Surgeries, clinics and private practices",
    pain: "Patient data demands the highest protection, and booking systems simply cannot afford downtime.",
    help: [
      "Security hardened around sensitive patient records",
      "Priority response when clinical systems are affected",
      "Backup routines tested against real restore drills",
    ],
  },
  {
    id: "construction-trades",
    icon: "HardHat",
    title: "Construction & Trades",
    tagline: "Builders, contractors and trade firms",
    pain: "Half the team is on site, half in the office, and neither can afford to lose drawings, quotes or job sheets.",
    help: [
      "Site-to-office connectivity that just works",
      "Cloud access to plans and documents from anywhere",
      "Practical support for rugged, mixed device fleets",
    ],
  },
  {
    id: "manufacturing-engineering",
    icon: "Factory",
    title: "Manufacturing & Engineering",
    tagline: "Workshops, fabricators and production firms",
    pain: "Production lines depend on a mix of legacy machines and modern systems that rarely play nicely together.",
    help: [
      "Legacy and modern systems kept running side by side",
      "Network separation to protect production equipment",
      "Planned maintenance windows, not surprise outages",
    ],
  },
  {
    id: "logistics-distribution",
    icon: "Truck",
    title: "Logistics & Distribution",
    tagline: "Hauliers, warehouses and courier firms",
    pain: "Every minute of downtime is a missed delivery window, and warehouse Wi-Fi dead zones cost real money.",
    help: [
      "Full-coverage warehouse and depot Wi-Fi",
      "Always-on systems with proactive monitoring",
      "Fast remote support for drivers and depot staff",
    ],
  },
  {
    id: "charities-nonprofits",
    icon: "HeartHandshake",
    title: "Charities & Non-Profits",
    tagline: "Third-sector organisations across Scotland",
    pain: "Tight budgets, donated hardware and volunteer teams make IT feel like a luxury you cannot afford.",
    help: [
      "Charity-discounted Microsoft 365 licensing done right",
      "Honest advice that respects every pound",
      "Simple security basics that protect donor data",
    ],
  },
];
